import { useQuery } from '@tanstack/react-query';
import type { CvDocumentSelection } from '@tabbio/types';
import { cvReviewEnabled, fetchCvEditionDocument, fetchCvEditionRevision, fetchCvReleaseRecord } from '../lib/cv-release-api';

export function useExactCvEdition(target: string, variantId: string | null, enabled = true, pinned?: CvDocumentSelection | null) {
  const query = useQuery({ queryKey: ['cv', target, 'selected-edition', variantId, pinned ?? null],
    queryFn: async () => {
      if (pinned?.releaseId) {
        const record = await fetchCvReleaseRecord(target, pinned.releaseId);
        return { ...record.document, locale: record.locale, direction: record.direction };
      }
      if (pinned?.variantId && pinned.revisionId) {
        const record = await fetchCvEditionRevision(target, pinned.variantId, pinned.revisionId);
        return { ...record.document, revisionId: record.id, revision: record.seq };
      }
      return fetchCvEditionDocument(target, variantId!);
    }, enabled: enabled && Boolean(target && (pinned || (cvReviewEnabled && variantId))),
    staleTime: Infinity, refetchOnWindowFocus: false });
  const data = query.data as Record<string, unknown> | undefined;
  const revisionId = data?.revisionId;
  const selection: CvDocumentSelection | undefined = pinned ? (data ? pinned : undefined) : variantId && typeof revisionId === 'string'
    ? { variantId, revisionId } : undefined;
  return { ...query, data, selection, ready: !(variantId || pinned) || Boolean(selection) };
}
